import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-raisoni-premier-league',
  templateUrl: './raisoni-premier-league.component.html',
  styleUrls: ['./raisoni-premier-league.component.scss']
})
export class RaisoniPremierLeagueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
